export const apiUrl = "https://backend.mine.page";
//export const apiUrl = "http://localhost:3000";
